/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * `publicRoutes` is available before authentication.
 * `protectedRoutes` is available after authentication and also drives the Sidenav.
 * Protected entries without a `type` are routable but hidden from the Sidenav.
 * Route keys use kebab-case, and URL values come from `routePaths.js`.
 */

// Routable pages
import Tutorial from "pages/tutorial";
import Overview from "pages/analysis/overview";
import SiteManager from "pages/sites/site-manager";
import DegradationSoiling from "pages/analysis/degradation-soiling";
import ServiceLife from "pages/analysis/service-life";
import PowerGenerationForecast from "pages/analysis/power-generation-forecast";
import EnvironmentalFinancial from "pages/analysis/environmental-financial";
import SiteMap from "pages/sites/map";
import SignIn from "pages/authentication/not-signed-in";
import SignOut from "pages/authentication/sign-out";
import CurrentName from "components/navigation/CurrentName";
import Pricing from "pages/pricing";
import AccountSettings from "pages/account/settings";
import AccountBilling from "pages/account/billing";
import AccountInvoices from "pages/account/invoices";
import AccountInvoiceDetail from "pages/account/invoice-detail";
import ROUTE_PATHS from "routePaths";

// Material Dashboard 2 PRO React components
// import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";
import BatteryCharging60 from "@mui/icons-material/BatteryCharging60";

// Images
// import profilePicture from "assets/images/team-3.jpg";

const publicRoutes = [
  {
    name: "Sign In",
    key: "sign-in",
    hidden: true,
    route: ROUTE_PATHS.signIn,
    component: <SignIn />,
  },
];

const protectedRoutes = [
  {
    type: "collapse",
    name: <CurrentName />,
    key: "current-user-name",
    // icon: <MDAvatar src={PersonOutlineIcon} alt="Brooklyn Alice" size="sm" />,
    icon: <Icon fontSize="medium">person_outline</Icon>,
    collapse: [
      {
        name: "Settings",
        labelKey: "settings",
        key: "settings",
        icon: <Icon fontSize="medium">settings</Icon>,
        route: ROUTE_PATHS.accountSettings,
        component: <AccountSettings />,
      },
      {
        name: "Billing",
        labelKey: "billing",
        key: "billing",
        icon: <Icon fontSize="medium">payment</Icon>,
        route: ROUTE_PATHS.accountBilling,
        component: <AccountBilling />,
      },
      {
        name: "Invoices",
        labelKey: "invoices",
        key: "invoices",
        icon: <Icon fontSize="medium">receipt</Icon>,
        route: ROUTE_PATHS.accountInvoices,
        component: <AccountInvoices />,
      },
      {
        name: "Logout",
        labelKey: "logout",
        key: "logout",
        icon: <Icon fontSize="medium">logout</Icon>,
        route: ROUTE_PATHS.signOut,
        component: <SignOut />,
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Tutorial",
    labelKey: "tutorial",
    key: "tutorial",
    icon: <Icon fontSize="medium">contact_support</Icon>,
    route: ROUTE_PATHS.tutorial,
    component: <Tutorial />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pricing",
    labelKey: "pricing",
    key: "pricing",
    icon: <Icon fontSize="medium">shopping_cart</Icon>,
    route: ROUTE_PATHS.pricing,
    component: <Pricing />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Site Manager",
    labelKey: "siteManager",
    key: "site-manager",
    icon: <Icon fontSize="medium">publish</Icon>,
    route: ROUTE_PATHS.siteManager,
    component: <SiteManager />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Overview",
    labelKey: "overview",
    key: "overview",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: ROUTE_PATHS.overview,
    component: <Overview />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Degradation/Soiling",
    labelKey: "degradationSoiling",
    key: "degradation-soiling",
    icon: <Icon fontSize="medium">trending_down</Icon>,
    route: ROUTE_PATHS.degradationSoiling,
    component: <DegradationSoiling />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Service life",
    labelKey: "serviceLife",
    key: "service-life",
    icon: <BatteryCharging60 fontSize="medium" />,
    route: ROUTE_PATHS.serviceLife,
    component: <ServiceLife />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Power generation forecast",
    labelKey: "powerGenerationForecast",
    key: "power-generation-forecast",
    icon: <Icon fontSize="medium">mode_of_travel</Icon>,
    route: ROUTE_PATHS.powerGenerationForecast,
    component: <PowerGenerationForecast />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Environmental and Financial Viability value",
    labelKey: "environmentalFinancial",
    key: "environmental-financial",
    icon: <Icon fontSize="medium">eco</Icon>,
    route: ROUTE_PATHS.environmentalFinancial,
    component: <EnvironmentalFinancial />,
    noCollapse: true,
  },
  {
    name: "Map",
    key: "map",
    hidden: true,
    route: ROUTE_PATHS.map,
    component: <SiteMap />,
  },
  {
    name: "Account Invoice Detail",
    key: "account-invoice-detail",
    hidden: true,
    route: ROUTE_PATHS.accountInvoiceDetail,
    component: <AccountInvoiceDetail />,
  },
];

export { publicRoutes, protectedRoutes };
